import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { setupInterceptor } from './interceptor'

Vue.config.productionTip = false
setupInterceptor()
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
